import React from 'react';
import { Container, Row, Col } from "react-bootstrap";
import Header from '../Header/Header';
import { Sidebar } from '../Sidebar/Sidebar';
import Footer from '../Footer';
import './styles.css'


function Layout(props) {
    const { children } = props;
    return (
        <>
        <Container fluid>
            <Row>
                <Header />
            </Row>
            <Row>
                <Col sm="2" className='sidebar-wrapper'><Sidebar /></Col>
                <Col className="page-content-wrapper">
                    {children}
                </Col>
            </Row>
            <Row>
                <Footer />
            </Row>
        </Container>
        </>
    );
}

export default Layout;